import { forwardRef } from "react";
import { Box } from "@mui/material";
import Button, { ButtonProps } from "@mui/material/Button";
import { IconCaret } from "src/components/icons-mui/caret";
import { Typography } from "src/components-mui/base/typography/typography";

interface IPopoverButton extends ButtonProps {
    title: string;
    isOpen: boolean;
    badgeInfo?: string;
}

export const PopoverButton = forwardRef<HTMLButtonElement, IPopoverButton>(function PopoverButton({ title, badgeInfo, isOpen, ...buttonProps }, ref) {
    return (
        <Button
            color="whiteAlpha"
            sx={{
                border: "1px solid",
                flex: 1,
                borderColor: "gray.300",
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
            }}
            {...buttonProps}
            ref={ref}
            endIcon={
                <IconCaret
                    sx={{
                        width: "24px",
                        height: "24px",
                        transition: "transform 0.3s",
                        transform: isOpen ? "rotate(180deg)" : "none",
                    }}
                />
            }
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Typography
                    sx={{
                        fontWeight: "fontWeightSemibold",
                        alignSelf: "center",
                        fontSize: "sm",
                    }}
                >
                    {title}
                </Typography>
                {badgeInfo && (
                    <Box
                        component="span"
                        sx={{
                            ml: 1,
                            py: 0.5,
                            px: 1,
                            backgroundColor: "blackAlpha.500",
                            borderRadius: "12px",
                            color: "white",
                            fontSize: "xs",
                            lineHeight: "1.15",
                            fontWeight: "fontWeightSemibold",
                        }}
                    >
                        {badgeInfo}
                    </Box>
                )}
            </Box>
        </Button>
    );
});
